import { Phone } from 'lucide-react';
import type { ReactNode } from 'react';
import { format } from '@/shared/lib';

type StationInfoProps = {
	stationName?: string;
	address?: string;
	phone?: string;
	distance?: number | null;
	actionSlot?: ReactNode;
};

const StationInfo = ({
	stationName,
	address,
	phone,
	distance,
	actionSlot,
}: StationInfoProps) => {
	const metricDistance =
		distance != null ? format.formatToMetric(distance) : null;

	return (
		<div className="flex items-start justify-between self-stretch pb-5">
			<div className="flex flex-col gap-2.5">
				<h1 className="font-semibold text-base text-mantang-black">
					{stationName}
				</h1>
				<div className="flex items-center gap-2 font-light text-mantang-gray-500 text-sm">
					<p>{address}</p>
					{metricDistance && (
						<>
							<div className="h-3 w-px bg-mantang-gray-500" />
							<p>{metricDistance}</p>
						</>
					)}
				</div>
				<p className="flex items-center gap-2 font-light text-mantang-gray-500 text-sm">
					<Phone className="w-3" />
					{phone}
				</p>
			</div>
			{actionSlot}
		</div>
	);
};

export default StationInfo;
